import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslation } from "@/hooks/useTranslation";
import { Trans } from "react-i18next";

type ItineraryLimitModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companiesCount: number;
  onConfirm: () => void;
};

export function ItineraryLimitModal({
  open,
  onOpenChange,
  companiesCount,
  onConfirm,
}: ItineraryLimitModalProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("prospecting.search.itinerary.limitModal.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Trans
              i18nKey="prospecting.search.itinerary.limitModal.description"
              values={{ count: companiesCount }}
              components={{ strong: <strong /> }}
            />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t("prospecting.search.itinerary.limitModal.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t("prospecting.search.itinerary.limitModal.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
